import {VaccineModel} from '../model/vaccine.model';

export const deduplicate = (array: VaccineModel[]): VaccineModel[] => {
    return array.filter((vaccine, index, self) =>
        index === self.findIndex((v) => v.abbreviation === vaccine.abbreviation)
    );
};
